import Types from '../types';

export default (reducerState = 0, action) => {
  switch (action.type) {
    case Types.SET_COUNT:
      return action.payload;
    default:
      return reducerState;
  }
};
